module.exports = __webpack_public_path__ + "img/PIC_franz.716b77cd.jpg";